import { css } from '@emotion/react';

export const styles = css`
  .js-focus-visible :focus:not(.focus-visible),
  .js-focus-visible :focus:not(.focus-visible) + [data-focus] {
    outline: none;
    box-shadow: none;
  }
  .grecaptcha-badge {
    visibility: hidden;
  }
`;
